import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServicecapabilityService {

  constructor(
    private http : HttpClient
  ) { }

  getAll(searchParams){
	return this.http.get(`${environment.JlUrl}/servicecapability`,{params:searchParams});
  }

  get(id){
	return this.http.get(`${environment.JlUrl}/servicecapability/`+id);
  }

  edit(id,formData){
	return this.http.put(`${environment.JlUrl}/servicecapability/`+id,formData);
  }

  create(formData){
	return this.http.post(`${environment.JlUrl}/servicecapability`,formData);
  }

  delete(id){
	return this.http.delete(`${environment.JlUrl}/servicecapability/`+id);
  }

}